module.exports = __webpack_public_path__ + "static/media/img-mobile-app-service.33a4a53f.png";